import React from "react";
import ReactTable from "@dhn/components/molecules/data-table";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import TabContent from "@dhn/components/atoms/tab-content";
import EnabledButton from "../../../../../../@dhn/components/molecules/status-button";
import CardHeaderTabs from "@dhn/components/molecules/card-header-tabs";
import BranchSubTab from "./subTabs/BranchSubTab";
import WorkTeamSubTab from "./subTabs/WorkTeamSubTab";
import InsurersSubTab from "./subTabs/InsurersSubTab";
import { UPDATE_BRANCH_OFFICE } from "../../../queries";
import { orderBy } from "lodash";

export default function BranchTab({
  actions,
  state,
  subTab,
  branchSelected,
  onChange,
  stateBranch,
  addToast,
  workTeamRows,
}) {
  if (!subTab) {
    return (
      <div className="animated fadeIn">
        <Row form className="mb-3">
          <Col md={8}>
            <Input
              type="text"
              placeholder="Buscar Sucursal"
              onChange={({ target: { value } }) => {
                const dataSearch = stateBranch.filter(
                  (item) =>
                    item.name &&
                    item.name.toLowerCase().includes(value.toLocaleLowerCase())
                );

                onChange("mapDataSearch", dataSearch);
              }}
            />
          </Col>
          <Col md="auto" className="ml-auto">
            <Button
              color="primary"
              className="btn-color-primary"
              onClick={() => {
                actions.onChange("branchSubTab", 1);
                onChange("isNewBranch", true);
              }}
            >
              <i className="fa fa-plus"></i>
              {" Agregar"}
            </Button>
          </Col>
        </Row>
        <Row form className="mb-4">
          <Col md={12}>
            <ReactTable
              className="-striped -highlight mt-2"
              defaultPageSize={10}
              data={orderBy(
                state.mapDataSearch?.length ? state.mapDataSearch : stateBranch,
                ["enabled", "name"],
                ["desc", "asc"]
              )}
              columns={[
                {
                  Header: "Sucursal",
                  accessor: "name",
                },
                {
                  Header: "Contacto",
                  accessor: "contact",
                },
                {
                  Header: "Teléfono",
                  className: "text-center",
                  accessor: "phone",
                },
                {
                  Header: "Opciones",
                  className: "text-center",
                  Cell: ({ original }) => {
                    return (
                      <FormGroup>
                        <Button
                          color="secondary"
                          type="button"
                          onClick={() => {
                            actions.onPayloadSaveUser(original);
                            onChange("isNewBranch", false);
                            onChange("mapDataSearch", []);
                          }}
                          className="btn-color-gray card-header-action"
                        >
                          <i className="fa fa-pencil"></i>
                          {" Editar"}
                        </Button>
                        <EnabledButton
                          status={original.enabled}
                          mutate={UPDATE_BRANCH_OFFICE}
                          itemId={original.id}
                          onCompleted={actions.refetchMedicalStaffProviders}
                        />
                      </FormGroup>
                    );
                  },
                },
              ]}
            />
          </Col>
        </Row>
      </div>
    );
  } else {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col md={12}>
            <Card>
              <CardHeaderTabs
                active={subTab}
                onClick={(tab) => onChange("branchSubTab", tab)}
                tabs={[
                  {
                    id: 1,
                    name: <div className="px-4">Sucursal</div>,
                  },
                  ...(stateBranch?.length && !state?.isNewBranch
                    ? [
                        {
                          id: 2,
                          name: <div className="px-4">Equipo</div>,
                        },
                        {
                          id: 3,
                          name: <div className="px-4">Aseguradoras</div>,
                        },
                      ]
                    : []),
                ]}
              />
              <CardBody className="p-2">
                <TabContent activeTab={subTab}>
                  {subTab === 1 && (
                    <BranchSubTab
                      onChange={onChange}
                      state={branchSelected}
                      params={actions?.params}
                    />
                  )}
                  {subTab === 2 && (
                    <WorkTeamSubTab
                      onChange={onChange}
                      mapDataSearch={state.mapDataSearch}
                      toggle={actions.toggle}
                      state={state.user}
                      rows={workTeamRows}
                      optionProfiles={state.dataOptionProfiles}
                      dataUserSelected={state.userSelected}
                      onAddAndModifyUser={actions.onAddAndModifyUser}
                      modalAddAndEditIsOpen={state.modalAddAndEditIsOpen}
                      isMedical={state.isMedical}
                      medicalSelected={state.medicalSelected}
                      showPassword={state.showPassword}
                      branchSelected={state.branchSelected}
                      profileSelected={state?.profileSelected}
                      isNew={state.isNewUser}
                      onAddAndModifyUserMedical={
                        actions?.onAddAndModifyUserMedical
                      }
                      actionsButtonEditUser={actions?.actionsButtonEditUser}
                      onRemoveUnsavedUser={actions?.onRemoveUnsavedUser}
                      addToast={addToast}
                      scheduleSelected={state.scheduleSelected}
                      schedulingFormat={state.schedulingFormat}
                    />
                  )}
                  {subTab === 3 && (
                    <InsurersSubTab
                      onChange={onChange}
                      state={state.arses}
                      optionArs={state.dataOptionArs}
                      arsesSelected={state.arsesSelected}
                      refetchMedicalStaffProviders={
                        actions.refetchMedicalStaffProviders
                      }
                      onAddAndModifyArs={actions.onAddAndModifyArs}
                      isNew={state.isNewArses}
                    />
                  )}
                </TabContent>
              </CardBody>
              <CardFooter>
                <div>
                  <Button
                    disabled={state.loadingOrCreateModification}
                    color="success"
                    className="btn-color-success mr-2"
                    onClick={actions.onAddAndModifyBranch}
                  >
                    <i
                      className={
                        state.loadingOrCreateModification
                          ? "fa fa-spinner fa-spin"
                          : "fa fa-plus"
                      }
                    ></i>
                    {state.loadingOrCreateModification
                      ? " Cargando..."
                      : state.isNew
                      ? " Agregar"
                      : " Modificar"}
                  </Button>
                  <Button
                    color="danger"
                    className="btn-color-danger"
                    onClick={actions.requestCancelBranch}
                  >
                    <i className="fa fa-times"></i>
                    {" Cancelar"}
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
